import { defineStore } from 'pinia'
import { AppStoreEnum } from '#lib/enums'
import type { RegisterAddon } from '#lib/types'
import { persistedState } from '#imports'

export const useRegisterAddonStore = defineStore(AppStoreEnum.RegisterAddon, {
  state: (): RegisterAddon => ({
    queries: {},
  }),
  persist: {
    storage: persistedState.localStorage,
  },
  actions: {
    setRegisterAddon(data: Record<string, string>) {
      this.queries = data
    },
  },
})
